import Vue from 'vue';
import api from 'src/api/site';
import TopBar from "components/TopBar";
import { Multiselect } from 'vue-multiselect';
import { BfDatepicker } from 'components/Butterfly';
export default Vue.extend({
    // required for old vee-validate2
    $_veeValidate: { validator: 'new' },
    components: { TopBar, Multiselect, BfDatepicker },
    data() {
        return {
            email: '',
            siteName: '',
            siteURLName: '',
            isLoading: false,
            hasSucceeded: null,
            errorMessage: '',
            chrysUrlChoices: [],
            chosenChrysUrl: this.urlChoices ? urlChoices[0] : '',
            projectColumnLimit: undefined,
            projectRowLimit: undefined,
            enforceRowLimit: false,
            termEnd: undefined
        };
    },
    computed: {
        adminUrl() {
            switch (process.env.APP_ENV) {
                case 'production': {
                    return 'https://django-admin.kapiche.com/admin/revealed_sites/siteprofile/';
                }
                case 'staging': {
                    return 'https://django-admin.kapiche-dev.com/admin/revealed_sites/siteprofile/';
                }
                case 'dev': {
                    return 'http://localhost:8000/admin/revealed_sites/siteprofile/';
                }
                default: {
                    return '';
                }
            }
        }
    },
    async created() {
        this.$validator.extend('site_available', {
            getMessage() {
                return 'Site name not available';
            },
            async validate(value) {
                if (!value) {
                    return false;
                }
                try {
                    const response = await api.checkSiteExists(value);
                    return response.valid;
                }
                catch (e) {
                    return false;
                }
            }
        });
        const response = await api.availableChrysUrls();
        this.chrysUrlChoices = response.options;
        this.chosenChrysUrl = response.default;
    },
    methods: {
        async submit() {
            this.hasSucceeded = null;
            this.errorMessage = '';
            try {
                this.isLoading = true;
                const valid = await this.$validator.validateAll();
                if (!valid) {
                    return;
                }
                await api.createSite(this.email, this.siteName, this.siteURLName, this.chosenChrysUrl, this.projectColumnLimit, this.projectRowLimit, this.enforceRowLimit, this.termEnd);
                this.hasSucceeded = true;
                setTimeout(() => this.$router.push({ name: 'start' }), 1500);
            }
            catch (e) {
                this.hasSucceeded = false;
                this.errorMessage = `${e.statusText}: ${e.bodyText}`;
            }
            finally {
                this.isLoading = false;
            }
        },
        /**
         * We're using the tagging functionality in vue-multiselect so that we can
         * add chrysalises that aren't already in use by a site and therefore aren't
         * an option in the dropdown.
         * @param <String> text
         */
        selectNewChrysalis(text) {
            this.chosenChrysUrl = text;
        }
    }
});
